<template>
  <div>
    <div v-for='welfareInfo in welfareItems' :key='welfareInfo.companyid'>
      <div class='banner'>
        <img  :src="welfareInfo.banner?welfareInfo.banner:welfareInfo.listPic" class="goods_pic" />
      </div>
      <div class='des mt15'>
        <div class='title'>
          <span>{{welfareInfo.title}}</span>
        </div>
        <div class='updateTime'>
          <span>{{welfareInfo.attention}}</span>
        </div>
        <div class="companyInfo">
          <span>{{welfareInfo.name}} | {{welfareInfo.createTime}}</span>
          <span>查看人数:{{welfareInfo.qmVisitCount}}</span>
        </div>
      </div>
      <div class="welfareBox mt15" v-show='welfareInfo.description'>
        <div class="descriptionTitle">
          <span class='descriptionTitle_inner'>福利简介</span>
        </div>
        <div class="description">
          <div class='description_text'>{{welfareInfo.description}}</div>
        </div>
      </div>
      <div class="welfareBox mt15" v-show='welfareInfo.helpText'>
     <div class="descriptionTitle">
       <span class='descriptionTitle_inner'>领取流程</span>
     </div>
     <div class="description">
       <div class='description_text'>{{welfareInfo.helpText}}</div>
     </div>
   </div>
   <div class="welfareBox mt15" v-if="welfareInfo.startTime!='0000-00-00 00:00:00'||welfareInfo.endTime!='0000-00-00 00:00:00'||welfareInfo.timeNote">
      <div class="descriptionTitle">
        <span  class='descriptionTitle_inner'>活动时间</span>
      </div>
      <div v-if="welfareInfo.startTime!='0000-00-00 00:00:00'" class="description">
        <text>开始时间：{{welfareInfo.startTime}}</text>
      </div>
      <div v-if="welfareInfo.endTime!='0000-00-00 00:00:00'" class="description">
        <text>结束时间：{{welfareInfo.endTime}}</text>
      </div>
      <div v-if="welfareInfo.timeNote" class="description">
        <div class='description_text'>{{welfareInfo.timeNote}}</div>
      </div>
    </div>
    <!--快车券-->
    <otherCoupon  :moreCoupons="welfareInfo.moreCoupons" :needClip="welfareInfo.needClip" :getLink = "getLink" v-if="moreCoupons" ></otherCoupon>
    <div class='getLinkWrapper' v-if="welfareInfo.couponLinkURL">
      <form @submit.prevent='getLink(welfareInfo.couponLinkURL,welfareInfo.needClip)'>
        <button class="getLink copy_btn" :data-clipboard-text="clipData" >领取福利</button>
      </form>
    </div>
    </div>
    <!--福利早知道-->
<!--div class='gzh'>
  <div class='gzh_btn'>
    <div class='gzh_content'>
      <div class='gzh_gift_wrapper'>
        <img src='../../images/gzh_gift.png' class='gzh_gift'>
      </div>
      <div class='gzh_text_wrapper'>福利早知道
      </div>
    </div>
  </div>
</div-->

<mt-popup class="copyBox"
v-model="copyBox"
position="top" :closeOnClickModal= false :modal= true >
  <div class="copyBoxContainer">
    <strong class="title">恭喜您!!!</strong>
    <p class="greetings">获得优惠券，复制后打开浏览器粘贴</p>
  <div class="btn_wrapper">
    <button class="one_copy_btn copy_btn"  :data-clipboard-text="clipData" @click="getCouponCopy">一键复制</button>
    <button class="close_copy_btn copy_btn" @click="closeModal">关闭</button>
  </div>
  </div>
</mt-popup>
  </div>
</mt-popup>
</template>
<script type = "text/ecamscript-6">
 import OtherCoupon from '@/components/welfare/otherCoupons'
 import Clipboard from 'clipboard'//复制函数
 import { Popup } from 'mint-ui';//弹出框
 Vue.component(Popup.name, Popup);
 import Vue from "vue"
  export default {
    name:"wfItem",
    data(){
      return{
        welfareItems:[],
        id:this.$route.params.id,
        moreCoupons:[],
        clipData:"",//复制初始值
        copyBox:false
      }
    },
    created(){
      this.login()
    },
    methods:{
      /*axios调用nav*/
       login () {
         this.url = "api/getWelfareInfo.php?welfareid="+this.id
         //console.log(this.url )
         this.$ajax.autoService
             .login(this.url)
             .then((res) => {
               this.welfareItems= this.welfareItems.concat(res.data.map(function(item){
                 if (item.moreCoupons != '') {
               var t = '[' + item.moreCoupons + ']'
               t = t.replace(/(^\s*)|(\s*$)/g, "")
               t = t.replace(/\'/g, '"')

               item.moreCoupons= JSON.parse(t);

               //console.log(item.moreCoupons)
             }
             if (!item.startTime) {
               item.startTime = '0000-00-00 00:00:00'
             }
             if (!item.endTime) {
               item.endTime = '0000-00-00 00:00:00'
             }
             if (item.description == '') {
               item.description = '点击领取福利，按相关说明领取。'
             }
                 return item
               }))
              console.log(this.welfareItems)
             }, (res) => {
                 console.log("error")
             })
        },
        //复制领券链接
        getLink(link,needClip) {
          //console.log(link)
          if(needClip == 0){
            window.location = link
          }
          else{
            this.copyBox = true;
            this.clipData = link
            this.getCouponCopy ()
          }
        },
        closeModal () {//关闭弹出框
          this.copyBox = false
        },
        getCouponCopy () {
          //复制函数

          var clipboard = new Clipboard('.copy_btn')
        //console.log(2)
           clipboard.on('success', e => {
             this.copyBox = false
             // console.info('Text:', e.text);
             //console.log('复制成功')
             // 释放内存
            clipboard.destroy()

           })
           clipboard.on('error', e => {
             // 不支持复制
             console.log('该浏览器不支持自动复制')
             // 释放内存
             clipboard.destroy()
           })
        },
    },
    components:{
      'otherCoupon':OtherCoupon
    }
  }
</script>
<style lang="stylus">
  .goods_pic
    width:100%
    display:block
  .des
    width:100%
    padding:30px
    box-sizing:border-box
    background:#fff
    .title
      font-size: 38px
      color: #333
    .updateTime
      font-size: 32px
      color: #f40
      margin-top: 10px
    .companyInfo
      font-size: 28px
      color: #999
      margin-top: 10px
      display: flex
      justify-content: space-between
  .welfareBox
    width: 100%
    padding: 34px 30px
    background: #fff
    box-sizing: border-box
    .descriptionTitle
      padding: 20px 0
      border-bottom: 1px solid #ddd
      /*px*/
      .descriptionTitle_inner
        border-left: 6px #ff4400 solid
        font-size: 30px
        color: #333
        display: block
        padding-left: 20px
        line-height: 30px
    .description
      font-size: 28px
      color: #333
      line-height: 40px
      .description_text
        margin-top:30px
  .getLinkWrapper
    width: 500px
    height: 120px
    .getLink
      display:block
      width: 500px
      height: 88px
      line-height: 88px
      border-radius: 44px
      background: linear-gradient(to right,#ff9e30,#ff5500)
      font-size: 34px
      color: #fff
      margin: 0 auto
      position: fixed
      left: 50%
      bottom: 121px
      z-index: 9
      transform: translateX(-50%)
      text-align:center
      border:0px
  .gzh
    width: 251px
    height: 104px
    position: fixed
    right: 0
    top: 200px
    background:url(../../images/gzh_bg.png)no-repeat left top
    background-size:251px 104px
    .gzh_btn
      width: 251px
      height: 104px
      position: absolute
      left: 0px
      top: 0px
      background: none
      line-height: 104px
      border-radius: none
      .gzh_content
        position: absolute
        z-index: 3
        top: 5px
        left: -10px
        display: flex
        justify-content: space-between
        .gzh_text_wrapper
          width: 150px
          color: #fff
          padding-right: 10px
          line-height: 80px
          font-size: 30px
          margin-left: -25px
          animation: typing 4s  infinite
          white-space: nowrap
          overflow: hidden
          padding-top: 3px
          text-shadow: 2px 2px 2px rgba(12,4,7,0.4)
          /*px*/
        .gzh_gift_wrapper
          width: 134px
          height: 107px
          display: block
          animation: gzhScale 2s linear infinite
          .gzh_gift
            width: 134px
            height: 107px
            display: block
            animation: gzhScale 2s linear infinite
  .mint-popup
    &.copyBox
      width:100%
      height:100%
      background:none
    .copyBoxContainer
      width:500px
      padding:30px 0 0 0
      position:fixed
      left:50%
      top:50%
      z-index:999
      background:#fff
      transform:translate(-50%,-50%)
      border-radius:20px
      overflow:hidden
      .title
        font-size:34px
        color:#f40
        display:block
        text-align:center
      .greetings
        font-size:28px
        color:#333
        text-align:center
        margin-top:10px
      .btn_wrapper
        display:flex
        margin-top:20px
        border-top:1px solid #f0f0f0
        /*px*/
        .close_copy_btn
          flex:1
          height:80px
          line-height:80px
          font-size:30px
          background:none
          border:0px solid #f0f0f0
          border-left:1px solid #f0f0f0
          /*px*/
        .one_copy_btn
          flex:1
          height:80px
          line-height:80px
          font-size:30px
          color:#f40
          border:0px solid #f0f0f0
          background:none
          @keyframes gzhScale{
          0%{
            transform: scale(0.6)
          }

           40%{
            transform: scale(0.9)
          }
           50%{
              transform: scale(1)
          }
          60%{
            transform: scale(0.9)
          }

          100%{
            transform: scale(0.6)
          }
        }

        @keyframes typing{
          from{
            width: 0
          }
        }
</style>



// WEBPACK FOOTER //
// src/components/welfare/item.vue